import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwTruncateNumber
 * @module mw.components.numberFormat
 *
 * @param {number} [number] - Number to be truncated.
 *
 * @description
 * `<md-truncate-number>` is a component used to display styled truncated numbers.
 *
 *
 * @usage
 * <hljs hljs-language="html">
 *   <mw-truncate-number number="1000000"></mw-truncate-number>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-truncate-number',
    template: `
        <span class="mw-truncate-number"><span class="mw-truncate-number__number">{{$ctrl.truncatedNumber}}</span><span class="mw-truncate-number__symbol">{{$ctrl.numberKey}}</span></span>
    `
})
export class TruncateNumberComponent implements OnInit, OnChanges {
    @Input('<') number: number = 0;
    mwTruncateNumberPipe;
    truncatedNumber: number = 0;
    numberKey: string = '';

    constructor(
        @Inject('$element') private $element: ng.IRootElementService,
        @Inject('$filter') private $filter: any) {
        'ngInject';

        this.mwTruncateNumberPipe = $filter('mwTruncateNumber');
    }

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes['number']) {
            const truncated = this.mwTruncateNumberPipe(changes.number.currentValue);
            [this.truncatedNumber, this.numberKey] = truncated.split(/([EQTBMk])/);
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/data-formatting/truncate-number.component.ts